import $ from 'jquery';
import { ISocialService } from '../socialService/socialService.factory';
import { IEventsService } from '../eventsService/eventsService.factory';

export type IWixBinding = ReturnType<typeof wixBinding>;

export interface ISettings {
  title?: string;
  name?: string;
  limitToggle: boolean;
  showDivider: boolean;
  eventMargin: number;
  showTitle: boolean;
  borderWidth: number;
  shareLinks: boolean;
  description: boolean;
  vertical: boolean;
  showBorder: boolean;
  notifyMe: boolean;
}
/* @ngInject */
export function wixBinding(
  wixSdk,
  $rootScope,
  $timeout,
  $q,
  eventsService: IEventsService,
  heightCalc,
  wixApi,
  socialService: ISocialService,
) {
  let styles = {
    booleans: {} as any,
    numbers: {} as any,
  };
  const settings: ISettings = {
    //Boolean params

    limitToggle: false,
    showTitle: false,
    notifyMe: false,
    shareLinks: false,
    showBorder: false,
    showDivider: false,
    vertical: false,
    description: false,
    borderWidth: 1,
    eventMargin: 30,
  };

  return {
    addListener,
    getSettings,
    update,
    initialSettings,
    updateWidgetHeight,
  };

  function getSettings() {
    return settings;
  }

  function addListener() {
    wixSdk.addEventListener(wixSdk.Events.SETTINGS_UPDATED, function (data) {
      if (data === 'data-update') {
        updateStrings();
      }
    });
    wixSdk.addEventListener(
      wixSdk.Events.STYLE_PARAMS_CHANGE,
      function (styleData) {
        update(styleData);
      },
    );
    wixSdk.addEventListener(wixSdk.Events.EDIT_MODE_CHANGE, function (data) {
      if (data.editMode === 'editor') {
        eventsService.allEvents();
      }
    });
    if (!wixApi.getMobileMode()) {
      $(window).resize(function () {
        const count = eventsService.eventCount();
        if (count === 0) {
          heightCalc.resizeNoShows();
        } else {
          heightCalc.resize();
        }
      });
    }
  }

  function initialSettings() {
    const defer = $q.defer();
    $timeout(function () {
      wixSdk.Styles.getStyleParams(function (styleParams) {
        styles = styleParams;
        $q.all([updateBooleans(), updateNumbers(), updateStrings()]).then(
          function () {
            //$rootScope.$apply();
            defer.resolve(settings);
          },
        );
      }, 0);
    });
    return defer.promise;
  }

  function updateBooleans() {
    const defer = $q.defer();
    $timeout(function () {
      const booleans = styles.booleans;
      if (booleans) {
        //settings.limitToggle = booleans.limitToggle;
        if (booleans.hasOwnProperty('showTitle')) {
          settings.showTitle = booleans.showTitle;
        } else {
          settings.showTitle = false;
        }
        if (booleans.hasOwnProperty('notifyMe')) {
          settings.notifyMe = booleans.notifyMe;
        } else {
          settings.notifyMe = true;
        }
        if (booleans.hasOwnProperty('shareLinks')) {
          settings.shareLinks = booleans.shareLinks;
        } else {
          settings.shareLinks = true;
        }
        if (booleans.hasOwnProperty('description')) {
          settings.description = booleans.description;
          eventsService.updateDescriptionSetting(settings.description);
        }
        if (booleans.hasOwnProperty('showBorder')) {
          settings.showBorder = booleans.showBorder;
          heightCalc.setBorder(settings.showBorder);
        }
        if (booleans.hasOwnProperty('showDivider')) {
          settings.showDivider = booleans.showDivider;
        } else {
          settings.showDivider = true;
        }
      }

      defer.resolve();
    }, 0);
    return defer.promise;
  }

  function updateNumbers() {
    const defer = $q.defer();
    $timeout(function () {
      const numbers = styles.numbers;
      if (numbers) {
        if (numbers.borderWidth) {
          settings.borderWidth = Math.round(numbers.borderWidth);
          heightCalc.setBorderWidth(settings.borderWidth);
        } else {
          settings.borderWidth = 1;
        }

        if (numbers.eventMargin) {
          settings.eventMargin = Math.round(numbers.eventMargin) + 30;
        } else {
          settings.eventMargin = 30;
        }
      }
      defer.resolve();
    }, 0);

    return defer.promise;
  }

  function updateStrings() {
    const defer = $q.defer();
    $timeout(function () {
      $q.all([updateArtistName(), updateTitle()]).then(function () {
        defer.resolve();
      });
    }, 0);
    return defer.promise;
  }

  function updateArtistName() {
    const defer = $q.defer();
    $timeout(function () {
      fetchString('name').then(function (data) {
        settings.name = data;
        eventsService.updateArtistName(settings.name);
        if (settings.name) {
          socialService.updateArtistName(settings.name);
        }
        defer.resolve();
      });
    }, 0);
    return defer.promise;
  }

  function updateTitle() {
    const defer = $q.defer();
    $timeout(function () {
      fetchString('title').then(function (title) {
        settings.title = title || 'Artist Name';
      });
      defer.resolve();
    }, 0);
    return defer.promise;
  }

  function _getPublicData(key) {
    return $q(function (resolve, reject) {
      wixSdk.Data.Public.get(
        key,
        { scope: wixSdk.Data.SCOPE.COMPONENT },
        resolve,
        reject,
      );
    }).then(function (data) {
      return data[key];
    });
  }

  function _getFontParam(key) {
    return $q(function (resolve) {
      wixSdk.Styles.getStyleParams(function (params) {
        resolve(params.fonts[key]);
      });
    });
  }

  function fetchString(key) {
    // copy exist settings/app/services/stringSaver.js
    return _getPublicData(key).catch(function (data) {
      let isNotFound;
      try {
        isNotFound = data.error.message.indexOf('not found') > -1;
      } catch (ex) {
        //other reason of exception
      }
      if (isNotFound) {
        return _getFontParam(key);
      }
      return $q.reject(data);
    });
  }

  function update(newStyles) {
    styles = newStyles;
    $q.all([updateBooleans(), updateNumbers(), updateStrings()]).then(
      function () {
        //$rootScope.$apply();
        heightCalc.scrollInit();
        updateWidgetHeight();
      },
    );
  }

  function updateWidgetHeight() {
    _getPublicData('showNumberOfShows').then((numberOfVisibleShows) => {
      const height = heightCalc.getHeightForNumber(numberOfVisibleShows);

      wixSdk.Settings.resizeComponent({ height });
    });
  }
}
